module.exports = __webpack_public_path__ + "media/images/v3/icon1-d05fa21f8c2af273f2c917666dce34cd.png";